import { api } from '@/services/api';
import type { DashboardSummary, ReviewQueueItem } from '@/services/types';

export interface DashboardData {
  summary: DashboardSummary;
  reviewQueue: ReviewQueueItem[];
}

export async function getDashboardSummary() {
  const response = await api.get<DashboardSummary>('/me/dashboard');
  return response.data;
}

export async function getReviewQueue(limit = 10) {
  const response = await api.get<ReviewQueueItem[]>('/srs/review-queue', {
    params: { limit },
  });
  return response.data;
}

export async function getDashboardData(limit = 10): Promise<DashboardData> {
  const [summary, reviewQueue] = await Promise.all([getDashboardSummary(), getReviewQueue(limit)]);
  return { summary, reviewQueue };
}
